import NumberFormatter from "@/services/NumberFormatter";

export default function percentage(
  value: number | undefined,
  valueForZero = "0",
  valueForUndefined = "-",
  valueForPositive = "+"
) {
  if (value === undefined) {
    return valueForUndefined;
  }

  if (value === 0 || isNaN(value) || !isFinite(value)) {
    return valueForZero;
  }

  let formatted = NumberFormatter.beautify(
    value,
    valueForZero,
    valueForUndefined
  );

  if (value && value >= 0) {
    formatted = `${valueForPositive}${formatted}`;
  }

  return `${formatted}%`;
}
